import { Box, Button, Typography } from '@mui/material';
import React, { useState } from 'react';

const MAX_LENGTH = 200;

const WelcomeText = () => {
  const [expanded, setExpanded] = useState(false);

  const handleExpand = () => {
    setExpanded(!expanded);
  };

  return (
    <Box p={2}>
      <Typography
        variant='h4'
        sx={{
          textAlign: 'center',
        }}
      >
        Rólunk
      </Typography>
      <Typography
        variant='subtitle1'
        sx={{
          pl: { xs: '8%', sm: '15%' },
          pr: { xs: '8%', sm: '15%' },
          textAlign: 'justify',
          mb: 1,
        }}
      >
        2010-ben kezdtük meg élelmiszer önellátó gazdaságunk kialakítását egy
        homokhátsági tanyán. Nem csupán egy agrármérnök házaspár vagyunk, hanem
        egy család, aki bebizonyítja, hogy a mai modern világban is lehet
        egészséges élelmiszert előállítani, függetlenedni a társadalmi
        rendszerektől, egy emberhez méltó, boldog vidéki életet élni, ahol kellő
        szakértelemmel felvértezve, egyszer csak azt veszed észre, hogy{' '}
        <strong>MINDENED MEGVAN</strong> amire szükséged van!
      </Typography>

      {expanded ? (
        <>
          <Typography
            variant='subtitle1'
            sx={{
              pl: { xs: '8%', sm: '15%' },
              pr: { xs: '8%', sm: '15%' },
              textAlign: 'justify',
              mb: 1,
            }}
          >
            A tanyaegyetem létrehozásával célunk, hogy hozzásegítsünk ahhoz a
            kiveszőben lévő tudáshoz, aminek segítségével függetlenedni tudsz az
            ellátó rendszerektől, szabad életet élhetsz, és egészséges, valóban
            tápláló élelemmel láthatod el családodat.
          </Typography>
          <Typography
            variant='subtitle1'
            sx={{
              pl: { xs: '8%', sm: '15%' },
              pr: { xs: '8%', sm: '15%' },
              textAlign: 'justify',
              mb: 1,
            }}
          >
            Ha mi meg tudtuk csinálni Neked is sikerülni fog!{' '}
          </Typography>
          <Typography
            variant='subtitle1'
            sx={{
              pl: { xs: '8%', sm: '15%' },
              pr: { xs: '8%', sm: '15%' },
              textAlign: 'justify',
              mb: 1,
            }}
          >
            Két gyermekünkkel élünk a Tulipános tanyán, egy közel 3 ha-os
            területen, a Homokhátságon. 2010 óta építjük élelmiszer önellátó
            gazdaságunkat. Mindketten okleveles agrármérnökként kerültünk az új
            életterünkbe, és fel kellett ismernünk azt, hogy a felsőoktatásban
            tanultak segítenek ugyan az új életünkben, de nem fedik a háztáji
            gazdálkodáshoz szükséges tapasztalatot.
          </Typography>
          <Typography
            variant='subtitle1'
            sx={{
              pl: { xs: '8%', sm: '15%' },
              pr: { xs: '8%', sm: '15%' },
              textAlign: 'justify',
              mb: 1,
            }}
          >
            A kezdetektől a célunk az volt, hogy megtermeljük a családunk
            számára szükséges egészséges, vegyszermentes élelmet. Már akkor
            láttuk, hogy a boltok polcait elárasztják az ipari élelmiszerek,
            telis-tele tartósítószerekkel, ízfokozókkal, színezőanyagokkal,
            amelyek egészségügyi kockázatai beláthatatlanok. Mellette azt is
            felismertük, hogy a biztos forrásból származó organikus termékek
            megfizethetetlenül drágák. Nem láttunk más megoldást az egészségünk
            megőrzésére, minthogy belevágunk egy olyan életbe, amely
            kihívásokkal teli, ámde szépségei kárpótolnak minket minden
            erőfeszítésünkért.
          </Typography>
          <Typography
            variant='subtitle1'
            sx={{
              pl: { xs: '8%', sm: '15%' },
              pr: { xs: '8%', sm: '15%' },
              textAlign: 'justify',
              mb: 1,
            }}
          >
            Senki nem volt körülöttünk, aki önellátó életet élne, és segítő
            kezet nyújtana az elakadásainkban. Nem volt előttünk egy olyan
            család képe, akik már megcsinálták, akik sikeresek, akik
            inspirálóak. Így a hitünk maradt az egyetlen kapaszkodónk abban,
            hogy képesek leszünk megvalósítani, amit elterveztünk, és ami a
            körülöttünk lévők szerint őrültség. Az elején nagyon egyedül éreztük
            magunkat, de talán ez kovácsolt minket tökéletesen össze.
          </Typography>
          <Typography
            variant='subtitle1'
            sx={{
              pl: { xs: '8%', sm: '15%' },
              pr: { xs: '8%', sm: '15%' },
              textAlign: 'justify',
              mb: 1,
            }}
          >
            Minden lehetőséget megragadva a paraszti hagyomány még fellelhető
            tudásmorzsáit gyűjtögettük, és sokszor kudarcok és veszteségek árán
            tapasztaltuk meg, melyik módszer válik be a családi gazdaságunkban.
          </Typography>
          <Typography
            variant='subtitle1'
            sx={{
              pl: { xs: '8%', sm: '15%' },
              pr: { xs: '8%', sm: '15%' },
              textAlign: 'justify',
              mb: 1,
            }}
          >
            Kettőnk évekig tartó, napi 16-18 órás munkájával meg is tudtuk
            valósítani az álmunkat. Állati termékből 100 %-ban, kertészeti
            termékekből 75%-ban önellátóvá váltunk.
          </Typography>
          <Typography
            variant='subtitle1'
            sx={{
              pl: { xs: '8%', sm: '15%' },
              pr: { xs: '8%', sm: '15%' },
              textAlign: 'justify',
              mb: 1,
            }}
          >
            Évek munkájával és idős, nálunk sokkal tapasztaltabb emberek
            felkutatásával megtanultuk, hogyan tudunk sikeresen élni egy
            paraszti hagyományokra alapozott életet a 21. század sodrásában.
          </Typography>
          <Typography
            variant='subtitle1'
            sx={{
              pl: { xs: '8%', sm: '15%' },
              pr: { xs: '8%', sm: '15%' },
              textAlign: 'justify',
              mb: 1,
            }}
          >
            Miközben fejlődtünk, a világ is változott körülöttünk, és egyre
            növekedett az igény a szabadabb, függetlenebb, egészségesebb élet
            iránt másokban is. Mára már közösség szinten éljük meg az
            önellátást, ami nagy terhet vesz le a vállunkról.
          </Typography>
          <Typography
            variant='subtitle1'
            sx={{
              pl: { xs: '8%', sm: '15%' },
              pr: { xs: '8%', sm: '15%' },
              textAlign: 'justify',
              mb: 1,
            }}
          >
            Nem akartuk azt, hogy másoknak is végig kelljen a nehézségekkel és
            kudarcokkal teli utat járni, ezért első lépésként megalapítottuk a
            Fenntartható visszafejlődés YouTube csatornát, amelynek célja, hogy
            a kezdeti bíztatást megadja azoknak, akik szívükben vágyják ezt a
            fajta életet, és a szabadságot.
          </Typography>
          <Typography
            variant='subtitle1'
            sx={{
              pl: { xs: '8%', sm: '15%' },
              pr: { xs: '8%', sm: '15%' },
              textAlign: 'justify',
              mb: 1,
            }}
          >
            Később Misi megjelentetett két könyvet, amelyek már konkrétan az
            élelmiszer önellátáshoz nyújtanak segítséget. Fenntartható
            visszafejlődés - Élelmiszer önellátás, és Fenntartható
            visszafejlődés 2. - A szelíd mezőgazdaság címmel.
          </Typography>
          <Typography
            variant='subtitle1'
            sx={{
              pl: { xs: '8%', sm: '15%' },
              pr: { xs: '8%', sm: '15%' },
              textAlign: 'justify',
              mb: 1,
            }}
          >
            Közben számtalan családdal találkoztunk, és támogattuk őket a
            tanyasi életük megvalósításában. Hosszas bíztató beszélgetések,
            elakadások kezelései és mentorálással töltött esték vannak
            mögöttünk. Mivel egyre nagyobb számban keresnek fel minket
            kiköltözni vágyók, ezért találnunk kellett egy megoldást arra,
            hogyan tudnánk az általunk felhalmozott, kiveszőben lévő tudást a
            leghatékonyabban átadni. Mostanra, hogy a videózásban is
            megszereztük a kellő tapasztalatot, úgy döntöttünk, hogy a Tanya
            Egyetem létrehozásával tudunk a legtöbb érdeklődőnek segítő kezet
            nyújtani.
          </Typography>
          <Typography
            variant='subtitle1'
            sx={{
              pl: { xs: '8%', sm: '15%' },
              pr: { xs: '8%', sm: '15%' },
              textAlign: 'justify',
              mb: 1,
            }}
          >
            Célunk, hogy minél több család háztartása váljon fogyasztóból
            termelővé, kiszolgáltatottból függetlenné, gyógyszerhasználóból
            egészségessé, mert a tudás az egyetlen hatalom.
          </Typography>
          <Typography
            variant='subtitle1'
            sx={{
              pl: { xs: '8%', sm: '15%' },
              pr: { xs: '8%', sm: '15%' },
              textAlign: 'justify',
              mb: 1,
            }}
          >
            Mindezek mellett viszont a legfőbb cél az, hogy a minket követők a
            segítségünkkel kapjanak egy bőségesen termő, áldásos életteret, ahol
            kiszakadva a fősodratból, megélhetik az emberhez méltó, nyugodt,
            szabad családi életet. Célunk, hogy megérezzék mennyire különlegesen
            áldott helyzetben vannak, mert van egy darabka földjük, amin
            megélhetik azt, amire teremtve vannak, a gondoskodva uralkodás
            örömét.
          </Typography>
          <Typography
            variant='subtitle1'
            sx={{
              pl: { xs: '8%', sm: '15%' },
              pr: { xs: '8%', sm: '15%' },
              textAlign: 'justify',
              mb: 1,
            }}
          >
            Szeretettel: Kriszti és Misi
          </Typography>
          <Button variant='outlined' color='primary' onClick={handleExpand}>
            Szöveg összezárása
          </Button>
        </>
      ) : (
        <>
          <Button variant='contained' color='primary' onClick={handleExpand}>
            (A teljes szöveg itt folytatódik...)
          </Button>
        </>
      )}
    </Box>
  );
};

export default WelcomeText;
